import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconClockFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 2.667c7.364 0 13.333 5.969 13.333 13.333S23.363 29.333 16 29.333 2.667 23.363 2.667 16 8.637 2.667 16 2.667M15.816 8.4c-.81 0-1.466.656-1.466 1.466V16.1c0 .389.155.763.43 1.038l4.033 4.032a1.467 1.467 0 0 0 2.074-2.074l-3.605-3.604V9.867c0-.81-.656-1.466-1.466-1.466" /></svg>;
export default SvgIconClockFilledSmall;